/**
 * Pick random element Исправить
 * @param {Array} options - array of all variants
 * @param {Array} correct - array of all correct variants
 * @param {String} type - type of current minigame
 * @param {String, Array} indices - choosen variant or array of indexes of choosen variants
 * @returns current state of the minigame.
 */

export default function ({ options, correct, type }, indices){
	if (type === 'Question') {
		return(correct === indices);
	}
	else{
		return(indices.every(i => correct.indexOf(options[i]) !== -1) && indices.length === this.data.correct_ans);
	}
}